import { useContext } from 'react';

// auth provider
import AuthWebContext, {
  AuthWebContextProps,
} from '../contexts/AuthWebContext';

// ==============================|| AUTH HOOKS ||============================== //

export default function useAuth(): AuthWebContextProps {
  const context = useContext(AuthWebContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
}
